export const CALENDAR_VIEW = 'calendarView';
export const CONNECTION = 'connection';
export const ESTIMATE = 'estimate';
export const KNOWLEDGE_BASE = 'knowledgeBase';
export const MAPPING = 'mapping';
export const MATCHING = 'matching';
export const MONDAY = 'monday';
export const REPLICATOR = 'replicator';
